module.exports = __webpack_public_path__ + "static/img/club-evnet-03.08bdf3f.jpg";